import type { ColumnDef } from '@tanstack/react-table';
import { createSerialColumn, MemberNameCell } from '@/components/common/DataTable';
import { formatNumber } from '@/utils/number';
import { PENDING_COLUMNS, type PendingSummaryRow } from '../types/pendingSummary.types';

function quantityCell(value: number) {
  return <span className="tabular-nums">{formatNumber(value)}</span>;
}

export function getPendingSummaryColumns(
  searchText: string | undefined,
): ColumnDef<PendingSummaryRow, unknown>[] {
  return [
    createSerialColumn<PendingSummaryRow>(),
    {
      accessorKey: 'reportingName',
      header: 'Reporting Name',
      cell: ({ row }) => (
        <MemberNameCell
          member={{
            name: row.original.reportingName,
            hrEmpId: row.original.reportingHrEmpId,
            mobile: row.original.reportingMobile,
          }}
          searchText={searchText}
        />
      ),
    },
    {
      accessorKey: 'entryPersonQty',
      header: 'Entry Person Qty',
      cell: ({ row }) => quantityCell(row.original.entryPersonQty),
    },
    ...PENDING_COLUMNS.map(
      (column): ColumnDef<PendingSummaryRow, unknown> => ({
        accessorKey: column.key,
        header: `${column.label} Qty`,
        cell: ({ row }) => quantityCell(row.original[column.key]),
      }),
    ),
    {
      accessorKey: 'total',
      header: 'Total Qty',
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">{formatNumber(row.original.total)}</span>
      ),
    },
  ];
}
